import Head from 'next/head';
import { useRouter } from 'next/router';
import {
  formatDateLang,
  isItUndefined,
  isMobile,
  replaceGlobalMetrics,
} from '../../util/DataUtil';
import { useSelector } from 'react-redux';
import React, { useEffect } from 'react';

export default function TemplateTitle({
  data,
  lang,
  color,
  read,
  global,
  itemCount,
  contentType,
  blockType,
  datetime,
}) {
  const url = useSelector((state) => state?.host?.host);
  const { asPath } = useRouter();
  const alias = asPath.substring(1);
  const timestamp = new Date().getTime();
  const isBlogAuthorVariant =
    data?.field_main_title_variant?.[0]?.value === 'blog_author_main_title';

  useEffect(() => {
    //handle blog author mobile size variant
    const handleResize = () => {
      if (isMobile(window.innerWidth) && isBlogAuthorVariant) {
        const templateBanner =
          document.getElementsByClassName('template-banner');
        if (templateBanner.length > 0) {
          const firstSpan = templateBanner[0].getElementsByTagName('span')[0];
          if (firstSpan) {
            firstSpan.style.maxHeight = '177px';
          }
        }

        const innerContainer =
          document.getElementsByClassName('inner-container');
        if (innerContainer.length > 0) {
          innerContainer[0].style.marginTop = '-120px';
        }
      } else {
        const templateBanner =
          document.getElementsByClassName('template-banner');
        if (templateBanner.length > 0) {
          const firstSpan = templateBanner[0].getElementsByTagName('span')[0];
          if (firstSpan) {
            firstSpan.style.maxHeight = '';
          }
        }

        const innerContainer =
          document.getElementsByClassName('inner-container');
        if (innerContainer.length > 0) {
          innerContainer[0].style.marginTop = '';
        }
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [isBlogAuthorVariant]);

  const renderArticlePublishDate = (stringDate) => {
    if (!stringDate) {
      return null;
    }

    return (
      <div className={'article-publish-date-container'}>
        <div className={'article-publish-date'}>
          {formatDateLang(stringDate)}
        </div>
        <div className={'horizontal-line'}></div>
      </div>
    );
  };

  return (
    <div>
      <div
        style={{ borderTop: '2px solid ' + color, position: 'relative' }}
        // itemCount
        //   ? `template-title template-title-${itemCount}`
        //   : 'template-title'
        className={`${itemCount ? `template-title template-title-${itemCount}` : 'template-title'}${isBlogAuthorVariant ? ' author-variant' : ''}`}
      >
        <Head>
          <meta
            name="twitter:title"
            content={data ? data?.field_template_title[0]?.value : ''}
          />
          <meta
            name="og:title"
            content={data ? data?.field_template_title[0]?.value : ''}
          />
        </Head>
        <div className={'top'}>
          <span>
            {blockType ? blockType[0]?.name : ''}
            {!blockType && isBlogAuthorVariant ? "Author" : ''}
            {read && read[0]?.value && (
              <span className={'read'}>, {read[0]?.value}</span>
            )}
          </span>
          <div className={'title-subtitle'}>
            <h1 className={'titleh'}>
              {global
                ? replaceGlobalMetrics(
                    data?.field_template_title[0]?.value,
                    global
                  )
                : ''}
            </h1>
            <div
              className={'subtitle'}
              dangerouslySetInnerHTML={{
                __html: data?.field_template_subtitle?.[0]?.value,
              }}
            ></div>
          </div>
          {contentType === 'press_release' && datetime && (
            <span className="datetime">{datetime ? datetime : ''}</span>
          )}
        </div>
        {isItUndefined(data?.field_hide_social_icons) !== '1' ? (
          <div className={'social'}>
            <a
              className={'a-template-title-link'}
              target="_blank"
              href={`https://twitter.com/share?text=${data?.field_template_title[0]?.value}&url=${url + '/' + alias}?t=${timestamp}&hashtags=digitalreality`}
              rel="noopener noreferrer"
            >
              <img alt="twitter" src={'/images/x.svg'} />
            </a>
            <a
              className={'a-template-title-link'}
              target="_blank"
              href={`https://www.linkedin.com/shareArticle?mini=true&url=${url + '/' + alias}?t=${timestamp}&title=${data?.field_template_title[0]?.value}&source=Digital reality?latest`}
            >
              <img alt="linkedin" src={'/images/linkedin.svg'} />
            </a>
          </div>
        ) : (
          <></>
        )}
      </div>
      {(contentType !== 'press_release' && datetime) &&
        renderArticlePublishDate(datetime)}
    </div>
  );
}
